import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../../ui/DataSelect";
import Box from "../../../../../../../../ui/Box";
import Progress from "../../../../../../../../ui/Progress";
import CardInfoField from "../../../../../../../../ui/CardInfoField";
import { ColoredStateIcon, StateTextColor } from "../../../../components/StateStyles";
import { format, parseISO } from 'date-fns';
import ru from 'date-fns/locale/ru';

const styles = () => ({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    },
    "& .MuiGrid-spacing-xs-4 > .MuiGrid-item": {
      paddingTop: 4,
      paddingBottom: 5
    }
  },
  container: {
    width: "100%",
    marginTop: "16px"
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  mainGrid:{
    marginTop: 8
  },
  block: {
    margin: "35px 0 15px 0"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 12
  },
  typofield: {
    width: 120,
    minWidth: 120,
    paddingRight: 16
  },
  typovalue: {
    fontSize: 12,
  },
  svgIcon:{
    display: "inline-block",
    marginBottom: "-8px",
    marginRight: "8px"
  },
});

const formatDate = date =>
  date ? format(parseISO(date), "dd.MM.yyyy", { locale: ru }) : null;

const ModuleMainInfo = ({
  classes,
  moduleInfo,
  disabled,
  moduleId
}) => {

  let skillName = moduleInfo.info.skillCis + (
    (moduleInfo.info.skillType && moduleInfo.info.skillType !=="")
    ? (' | ' + moduleInfo.info.skillType) : '') + (
      (moduleInfo.info.skillName && moduleInfo.info.skillName!=="")
      ? (' | ' + moduleInfo.info.skillName) : '');

  let specName = moduleInfo.info.specCode + (
    (moduleInfo.info.specName && moduleInfo.info.specName!=="")
    ? ' | '+moduleInfo.info.specName : '');

    return(
      (moduleInfo.data && moduleInfo.info) ? (
      <div className={classes.root}>
        <Typography className={classes.heading}>Основные сведения</Typography>
        <Grid container spacing={1} className={classes.mainGrid}>
          <Grid item xs={6}>
            <TextField
              value={moduleInfo.data.code ? `${moduleInfo.data.code}  |  ${moduleInfo.data.name}` : moduleInfo.data.name}
              label="Наименование"
              readOnly={true} hoverStateEnabled={false}
            />
            <TextField
              value={skillName}
              label="Компетенция"
              readOnly={true} hoverStateEnabled={false}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              value={specName}
              label="Профессия"
              readOnly={true} hoverStateEnabled={false}
            />
            <Grid container spacing={2}>
              <Grid item xs={3}>
                <TextField
                  value={moduleInfo.data.year}
                  label="Год"
                  readOnly={true} hoverStateEnabled={false}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={moduleInfo.info.duration}
                  label="Объём"
                  readOnly={true} hoverStateEnabled={false}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={moduleInfo.info.educationFormName}
                  label="Форма обуч."
                  readOnly={true} hoverStateEnabled={false}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  value={moduleInfo.info.trialFormName}
                  label="Форма аттест."
                  readOnly={true} hoverStateEnabled={false}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <TextField
          value={moduleInfo.data.description}
          label="Описание"
          readOnly={true} hoverStateEnabled={false}
        />

          <div className={classes.block}>
            <div className={classes.blockrow}>
              <Typography
                className={classes.typofield}
                variant="caption"
                color="textSecondary">
                Статус модуля:
              </Typography>
              <Typography className={classes.typovalue} variant="caption">
                {ColoredStateIcon(moduleInfo.info.statusId)}
                <span style={{
                  color: StateTextColor(moduleInfo.info.statusId)
                }}>{moduleInfo.info.statusName}</span>
              </Typography>
            </div>
            <div className={classes.blockrow}>
              <CardInfoField field="Дата создания:" value={formatDate(moduleInfo.info.creationDate)} wide="true"/>
            </div>
            {moduleInfo.info.expertise &&
            <div className={classes.blockrow}>
              <CardInfoField field="Дата экспертизы:" value={moduleInfo.info.expertise ? formatDate(moduleInfo.info.expertise.statusDate) : '-'} wide="true"/>
            </div>
            }
            <div className={classes.blockrow}>
              <CardInfoField field="Дата публикации:" value={formatDate(moduleInfo.info.publicationDate)} wide="true"/>
            </div>
          </div>
      </div>) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )
    );
}

export default withStyles(styles)(ModuleMainInfo);
